import { useState, useEffect } from "react";
import {
  BodyComponent,
  TableComponent,
  ActionComponent,
  CreateButton, RefreshButton,
  trans,
  HeaderComponent,
  PaginationComponent
} from "@comps/components";
import { makeRequest } from "@utils/helpers";
import { Commons, Const } from "../../constants";
import { Button, Tooltip, message } from 'antd';
import { UserAddOutlined } from "@ant-design/icons";
import { FilterComponent, FilterButton } from "@comps/components";
import { deleteDataReq, getAllDataReq, getFilterReq } from "./requests";
import CreateLeaveType from "./components/CreateLeaveType";
import UpdateLeaveType from "./components/UpdateLeaveType";
import ApplyLeaveType from "./components/ApplyLeaveType";

const langKey = Const["leaveType"].lngKey;
const pageConfig = {
  headers: {
    title: trans(`${langKey}.moduleName`),
    breadcrumb: [
      {
        name: trans(`${langKey}.moduleName`),
        path: Const["leaveType"].route
      }
    ]
  }
}
const IndexLeaveTypes = (props) => {
  const totalRecords = 0;
  const [dataSource, setDataSource] = useState([]);
  const [loader, setLoader] = useState(false);
  const [childComponent, setChildComponent] = useState(null);

  const [filters, setFilters] = useState();
  const [currentPage, setCurrentPage] = useState(1)
  const [pagination, setPagination] = useState({
    "total": 0,
    "count": 0,
    "per_page": 0,
    "current_page": 0,
    "total_pages": 0,
    "links": {}
  });


  // ==================================
  //   Use States End
  // ==================================

  // ================================== UpdateLocation
  //   Table Data End
  // ==================================

  const columns = [
    {
      key: 'code',
      title: trans(Commons.code),
      dataIndex: "code",
    },
    {
      key: 'name',
      title: trans(Commons.name),
      dataIndex: "name",
    },
    {
      key: 'acc_count',
      title: trans(`${langKey}.acc_count`),
      dataIndex: "acc_count",
    },

    {
      key: trans(Commons.actions),
      title: trans(Commons.actions), fixed: 'right',

      render: (record) => (
        <ActionComponent
          each={ record } modkey={ props.modkey }
          onDelete={ onDelete }
          onEdit={ onEdit }
          onView={ onView }
        >
          <Tooltip title="Assign this policy">
            <Button
              type="link"
              size="middle"
              className="da-px-10 da-my-0 base-table-action-btn base-table-action-btn--add"
              onClick={ () => onAssignRecord(record) }
            >
              <UserAddOutlined className="icon-style" />
            </Button>
          </Tooltip>
        </ActionComponent>
      ),
    },
  ];

  // ==================================
  //   Table Data End
  // ==================================

  useEffect(() => {
    getAllData();
    // eslint-disable-next-line
  }, [filters, currentPage]);

  const getAllData = () => {
    const payload = {
      page: currentPage,
      filters: filters
    }
    makeRequest(setLoader, getAllDataReq, payload, onSuccess, null);
  };

  const onSuccess = (response) => {
    setPagination(response.leave_types);
    setDataSource(response.leave_types.data);
  };

  const onEdit = (record) => {
    setChildComponent(
      <UpdateLeaveType onCompleted={ onCompleted } record={ record } disabled={ false } />
    );
  };

  const onView = (record) => {
    setChildComponent(
      <UpdateLeaveType onCompleted={ onCompleted } record={ record } disabled={ true } />
    );
  };

  const onDelete = (record) => {
    makeRequest(setLoader, deleteDataReq, record.id, onDeleted, onError);
  };
  const onDeleted = (res) => {
    onSuccess(res)
    setDataSource(res.leave_types.data);
    message.success("Record Deleted")
  };

  const onError = (err, res) => {
    message.error(res.response.data.message);
  }

  // Create component modal
  const onCreate = () => {
    setChildComponent(<CreateLeaveType onCompleted={ onCompleted } onSuccess={ onSuccess } />);
  };

  const onCompleted = (data) => {
    if (data.length) {
      setDataSource(data);
    }
    setChildComponent(null);
  };

  const handleTableChange = (page, fil, sorter) => {
    let payload = {
      ...pagination,
      current: page.current,
      pageSize: page.pageSize,
      sortName: sorter.field || "id",
      sortType: sorter.order === "ascend" ? "asc" : "desc",
    };
    setPagination(payload);
  };

  //---------------filters-----------------------
  const onOpenFilter = () => {
    setChildComponent(<FilterComponent filters={ filterFields } modkey={ props.modkey } selected={ filters } api={ getFilterReq } setCurrentPage={ setCurrentPage } onFilter={ setFilters } onCloseFilter={ onCloseFilter }
    />
    )
  }

  const onCloseFilter = () => {
    setChildComponent(null);
  }

  //----end filter--------------------
  //==================================On Apply Leave====================================
  const onApply = () => {
    setChildComponent(<ApplyLeaveType onCompleted={ onCompleted } record={ dataSource } />);
  }

  const onAssignRecord = (record) => {
    setChildComponent(
      <ApplyLeaveType
        onCompleted={ onCompleted }
        record={ [record] }
        initialLeaveTypeIds={ [record.id] }
      />
    );
  }
  //============================================================================
  return (
    <>

      { childComponent }
      <BodyComponent>
        <HeaderComponent headers={ pageConfig.headers } modkey={ props.modkey }>
          <RefreshButton onClick={ getAllData } /> <CreateButton onClick={ onCreate } />
          <CreateButton onClick={ onApply } text='Assign to employees' />
          <FilterButton onClick={ onOpenFilter } />
        </HeaderComponent>
        <TableComponent modkey={ props.modkey }
          loader={ loader }
          columns={ columns }
          dataSource={ dataSource }
          pagination={ { ...pagination, total: totalRecords } }
          onChange={ handleTableChange }
        />
      </BodyComponent>
      <PaginationComponent pagination={ pagination } modkey={ props.modkey } setCurrentPage={ setCurrentPage } currentPage={ currentPage } />
    </>
  );
};

export default IndexLeaveTypes;
const filterFields = [
  {
    type: "text",
    placeholder: "Name",
    key: "name"
  },
  {
    type: "text",
    placeholder: "Code",
    key: "code"
  },
  {
    type: "text",
    placeholder: "Accumulative Count",
    key: "accumulative_count"
  },
  {
    type: "select",
    placeholder: 'Status',
    key: "is_active",
    data_key: "supporting_data.is_active",
  },
  {
    type: "select",
    placeholder: 'Gender',
    key: "gender",
    data_key: "supporting_data.gender",
  },
  {
    type: "select",
    placeholder: 'Is Short',
    key: "is_short",
    data_key: "supporting_data.is_short",
  },
  {
    type: "select",
    placeholder: 'Encashable',
    key: "is_encashable",
    data_key: "supporting_data.is_encashable",
  },
  {
    type: "select",
    placeholder: 'Pro Rated',
    key: "is_pro_rated",
    data_key: "supporting_data.is_pro_rated",
  },
]
